module.exports = __webpack_public_path__ + "static/img/01st.46cdcdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/01st.jpg
// module id = 7KbB
// module chunks = 0